import { useSync } from '../sync/useSync'
import { aparenciaDoBotao, type EstadoSalvamento } from './rotuloSalvamento'

const CLASSES_VARIANTE = {
  normal: 'bg-teal-700 text-white',
  sucesso: 'bg-emerald-600 text-white',
  erro: 'bg-red-600 text-white',
} as const

// Unico lugar que consulta a fila de sincronizacao: as telas de cadastro nao
// precisam saber que a outbox existe.
export default function BotaoSalvar({
  estado,
  children,
  type = 'submit',
  onClick,
  className = 'w-full rounded-lg py-2 font-medium',
}: {
  estado: EstadoSalvamento
  children: string
  type?: 'submit' | 'button'
  onClick?: () => void
  className?: string
}) {
  const { pendencias } = useSync()
  const aparencia = aparenciaDoBotao(estado, children, pendencias > 0)
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={aparencia.desabilitado}
      className={`${className} ${CLASSES_VARIANTE[aparencia.variante]} disabled:opacity-60`}
    >
      {aparencia.rotulo}
    </button>
  )
}
